import { useState } from 'react'

const useModal = (props) => {
  const [isShowing, setIsShowing] = useState(props?.defaultValue || false)

  function toggle() {
    setIsShowing(!isShowing)
  }

  function close() {
    setIsShowing(false)
  }

  return {
    isShowing,
    toggle,
    close
  }
}

export default useModal
